import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from 'reactstrap';
import { FMessage } from '../../../hoc/IntlComponents';
import NewIFrameSettingGroup from './NewIFrameSettingGroup';
import NewIFrameCounstrucorPreview from './NewIFrameConstructorPreview';
import NewIFrameConstructorLink from './NewIFrameConstructorLink';

const NewIFrameConstructor = ({
  isOpen,
  toggle,
  streamLink,
  currentIFrameSettings,
  streamLandingSettings,
  currentLandingSettingsOverrides,
  handleCurrentLandingSettingsOverridesChange,
  iframeConstructorLoading,
  handleIFrameConstructorSave,
}) => {
  // local settings identical to global
  const [draftIFrameSettings, setDraftIFrameSettings] = useState({});
  const previewRef = useRef(null);

  // setup initial values and update draft on update global
  useEffect(() => {
    setDraftIFrameSettings(currentIFrameSettings);
  }, [currentIFrameSettings]);

  const handleCancelClick = () => {
    setDraftIFrameSettings(currentIFrameSettings);
    toggle();
  };

  const handleSaveClick = () => {
    handleIFrameConstructorSave(draftIFrameSettings);
  };

  const handleGlobalSettingsChange = (mutatorFunction) => {
    setDraftIFrameSettings((prev) => mutatorFunction({ ...prev }));
  };

  return (
    <Modal isOpen={isOpen} centered className="iframe-constructor-modal">
      <ModalHeader toggle={toggle}>
        <FMessage id="iframe_constructor.title" />
      </ModalHeader>
      <ModalBody>
        {iframeConstructorLoading ? (
          <FMessage if="iframe_constructor.loading" />
        ) : (
          <Row>
            <Col md={6}>
              {streamLandingSettings.iframe?.fields?.length
                ? streamLandingSettings.iframe.fields.map((el) => (
                    <NewIFrameSettingGroup
                      key={el.id}
                      title={el.title}
                      path={`iframe/20/${el.id}`}
                      fields={el.fields}
                      handleGlobalSettingsChange={handleGlobalSettingsChange}
                      globalSettings={draftIFrameSettings}
                      currentLandingSettingsOverrides={currentLandingSettingsOverrides}
                      handleCurrentLandingSettingsOverridesChange={
                        handleCurrentLandingSettingsOverridesChange
                      }
                    />
                  ))
                : null}
            </Col>
            <Col md={6}>
              <NewIFrameCounstrucorPreview settings={draftIFrameSettings} forwardRef={previewRef} />
              <NewIFrameConstructorLink
                streamLink={streamLink}
                width={
                  draftIFrameSettings['iframe/20/14/24']
                    ? `${draftIFrameSettings['iframe/20/14/23']}px`
                    : '100%'
                }
                previewRef={previewRef}
              />
            </Col>
          </Row>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" outline type="button" onClick={handleCancelClick}>
          <FMessage id="main.cancel" />
        </Button>
        <Button color="primary" type="button" onClick={handleSaveClick}>
          <FMessage id="main.save" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { NewIFrameConstructor };
